require('../bootstrap');

import env from '../config/loadEnv';
import router from '../router/index'

const baseURL = env.baseURL;
const normalURL = env.normalURL;
const portalUrl = env.portalAdmin;

const store = {
    state: {
        user: {
            name: '',
            photo: '',
            job: '',
            email: '',
            is_admin: '',
            id: 0
        },
        usuario_id: 0,
        authenticated: false,
        token: '',
        api: baseURL,
        url: normalURL,
        portalUrl: portalUrl,
        breadcrumbs: [{ name: "Home", route: "/" }],
    },
    getters: {
        token: state => {
            return state.token;
        },
        authenticated: state => {
            if (state.token == null || state.token == 'null') {
                return false;
            }

            return state.authenticated;
        },
        logo: state => {
            return state.logo;
        },
        user: state => {
            return state.user;
        },
        api: state => {
            return state.api;
        },
        breadcrumbs: state => {
            return state.breadcrumbs;
        }
    },
    mutations: {
        auth(state, token) {

            if (token != null && token != undefined) {
                state.authenticated = true;
                state.token = token;

                /* localStorage.clear(); */
                localStorage.removeItem('token');
                localStorage.setItem('token', token);

                axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('token');
                this.commit('profileUpdate');
            }
        },
        usuario_id(state, usuario_id) {

            if (usuario_id != null && usuario_id != undefined) {
                state.usuario_id = usuario_id;
                localStorage.removeItem('usuario_id');
                localStorage.setItem('usuario_id', usuario_id);
            }
        },
        usuario_nome(state, usuario_nome) {

            if (usuario_nome != null && usuario_nome != undefined) {
                state.usuario_nome = usuario_nome;
                localStorage.removeItem('usuario_nome');
                localStorage.setItem('usuario_nome', usuario_nome);
            }
        },
        profileUpdate(state) {
            axios.post(state.api + 'me', {
                token: state.token
            })
                .then(response => {

                    const userData = response.data;

                    if (JSON.stringify(state.user) !== JSON.stringify(userData)) {
                        state.user = userData;

                        localStorage.setItem('accept_terms', userData.accept_terms);
                        localStorage.setItem('access_nivel', '3');
                    }

                    if (userData.paciente_id == null) {
                        router.push('/editar-perfil');
                    }

                })
                .catch(error => {
                    localStorage.clear();

                    router.push('/login');
                });
        },
        updateBreadCrumbs(state, newRoute) {
            if (state.breadcrumbs.length > 1) {
                state.breadcrumbs.pop();
            }
            state.breadcrumbs.push(newRoute)
            // state.breadcrumbs = newRoute;
        },
    },
    actions: {
        initialize(context) {
            const token = localStorage.getItem('token');
            context.commit('auth', token);

            const usuario_id = localStorage.getItem('usuario_id');
            context.commit('usuario_id', usuario_id);

            const usuario_nome = localStorage.getItem('usuario_nome');
            context.commit('usuario_nome', usuario_nome);

        },
    }
};

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js